<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="标题" prop="title">
                        <Input v-model="info.title" 
                            :readonly="true" 
                            :maxlength="256" 
                            placeholder>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="正文" prop="content">
                        <Input type="textarea"
                            :readonly="true"
                            v-model="info.content"
                            placeholder="0/1000"
                            :rows="4" :maxlength="1000">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="附件" prop="attachments">
                        <preview-upload v-model="info.attachments"
                            :readonly="true" :format="imgSuffix">
                        </preview-upload>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="回复" prop="reply">
                        <Input type="textarea" v-model="info.reply"
                            :readonly="readonly"
                            placeholder="0/1000"
                            :rows="4" :maxlength="1000">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { feedbackView, reply } from '@/api/feedback'
import PreviewUpload from '_c/preview-upload'

export default {
    name: 'FormFeedback',

    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: {PreviewUpload},

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            imgSuffix: this.$config.upload.imgSuffix,
            info: {
                id: this.id,
                title: '',      // 标题
                content: '',    // 反馈内容
                attachments: '',// 附件
                reply: '',      // 回复
                ver: '',        // 版本号
                createUserId: ''// 反馈人编号
            }
        }
    },

    computed: {
        canSave() {
            return this.$can('update')
        },

        readonly() {
            return !this.canSave
        },

        ruleValidate() {
            return {}
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return feedbackView(this.id)
            }
        }
    },

    mounted() {
        var $info = this.$refs.info

        if (!this.canSave) {
            this.$modal.updateBtns([
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        } else {
            this.$modal.updateBtns([
                { type: 'primary', text: '确定', name: 'confirm' },
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        }

        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([this.fetch()])
                .then(args => {
                    var [view] = args

                    if (view) {
                        var viewData = view.data
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info.validate().then(() => {
                    var formData = Object.assign({}, this.info)
                    if (this.id) {
                        return reply(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    }
                })
                .catch(err => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>
